export default "__VITE_ASSET__9ef0532f__"